function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "social-icons",
  transform: "translate(-31.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "twitter",
  transform: "translate(32.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#000000",
  strokeWidth: 1.6,
  x: 0,
  y: 0,
  width: 23.2,
  height: 23.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5553686,7.98998838 C17.5655249,8.1299817 17.5655249,8.2700058 17.5655249,8.40999911 C17.5655249,12.6799799 14.2660432,17.6 8.23555092,17.6 C6.37766866,17.6 4.65178692,17.0699769 3.2,16.1500165 C3.46396978,16.1799975 3.71775202,16.1900014 3.99187809,16.1900014 C5.52485283,16.1900014 6.93604584,15.6800169 8.0629565,14.8100145 C6.62132586,14.7800027 5.41319615,13.8500076 4.99694452,12.5699983 C5.2,12.5999793 5.40303986,12.6199872 5.61625944,12.6199872 C5.91066684,12.6199872 6.20510549,12.5799715 6.47920031,12.5100056 C4.97666319,12.2099804 3.84972129,10.9099941 3.84972129,9.33999428 L3.84972129,9.3 C4.28625424,9.54001111 4.79391248,9.69000834 5.33194583,9.7099854 C4.44869238,9.12997352 3.87003387,8.13998562 3.87003387,7.01997754 C3.87003387,6.4199886 4.03244075,5.86998848 4.31672311,5.38998502 C5.93094817,7.34998377 8.3573639,8.62996222 11.0781558,8.76998632 C11.0274056,8.52998459 10.9969367,8.28000972 10.9969367,8.03000406 C10.9969367,6.24998353 12.4588799,4.8 14.276137,4.8 C15.220297,4.8 16.0730815,5.18999897 16.6720839,5.81999966 C17.4131805,5.68000635 18.1238395,5.40999286 18.7533108,5.04000173 C18.5096223,5.79001869 17.9918703,6.42001938 17.3116801,6.81999149 C17.971589,6.75002561 18.6111852,6.56998584 19.2,6.32001097 C18.7533733,6.9599848 18.1949648,7.52996198 17.5553686,7.98998838 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}))));

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6e8f44d1.svg";
export { ForwardRef as ReactComponent };